import {
  CustomerJob as APICustomerJob,
  CustomerJobType as APICustomerJobType,
  CustomerJobStatus as APICustomerJobStatus,
} from 'api/domain/entities/CustomerJob';

export type CustomerJob = APICustomerJob;

export type CustomerJobType = APICustomerJobType;

export type CustomerJobStatus = APICustomerJobStatus;
export const CustomerJobStatus = APICustomerJobStatus;
